<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      tData: {
        historyUpload: [
          {
            id: '1',
            time: '12 Sep 2022',
            name: 'file.xls',
            status: 0,
            uploader: 'Joni',
          },
          {
            id: '2',
            time: '12 Sep 2022',
            name: 'file.xls',
            status: 1,
            uploader: 'Joni',
          },
          {
            id: '3',
            time: '12 Sep 2022',
            name: 'file.xls',
            status: 2,
            uploader: 'Joni',
          },
          {
            id: '4',
            time: '12 Sep 2022',
            name: 'file.xls',
            status: 0,
            uploader: 'Joni',
          },
          {
            id: '5',
            time: '12 Sep 2022',
            name: 'file.xls',
            status: 1,
            uploader: 'Joni',
          },
        ],
      },
    }
  },
  computed: {
    /**
     * Total no. of records
     */

    rows() {
      return this.tData.historyUpload.length
    },

    title() {
      return 'Unggah'
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
        },
        {
          text: this.$t('menuitems.masterData.list.employee'),
        },
        {
          text: 'Unggah',
        },
      ]
    },
    historyUpload() {
      return [
        {
          key: 'time',
          label: 'Waktu',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Nama ',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'uploader',
          label: 'Diunggah Oleh',
          sortable: true,
        },
      ]
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">
        {{ $t('master.empoyee.employeePage') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-b-modal.modal-history-upload
            variant="secondary"
            class="ms-3"
            icon="icon-outline_file-text"
            :text="$t('global.importResult.historyUpload')"
          />
          <McButton
            variant="primary"
            class="ms-2"
            icon="icon-outline_upload"
            :text="$t('global.importResult.uploadAgain')"
            @click="$router.push({ name: 'Master Employee Import' })"
          />
          <McButtonBack />
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="mc-upload">
          <div class="mc-upload-result mc-upload-result--success">
            <figure>
              <img src="@/assets/images/success-icon.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">
              {{ $t('global.importResult.successUpload') }}
            </h4>
            <ul class="mc-upload-result__detail">
              <li><b>5</b> {{ $t('global.importResult.total') }}</li>
              <li class="text-success"><b>5</b> {{ $t('global.importResult.successData') }}</li>
              <li class="text-danger"><b>5</b> {{ $t('global.importResult.failedData') }}</li>
            </ul>
          </div>
          <div class="mc-upload-result mc-upload-result--warning" style="display: none">
            <figure>
              <img src="@/assets/images/warning-icon.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">
              {{ $t('global.importResult.partialSuccess') }}
            </h4>
            <ul class="mc-upload-result__detail">
              <li><b>5</b> {{ $t('global.importResult.total') }}</li>
              <li class="text-success"><b>5</b> {{ $t('global.importResult.successData') }}</li>
              <li class="text-danger"><b>5</b> {{ $t('global.importResult.failedData') }}</li>
            </ul>
            <McButton
              icon="icon-outline_download"
              :text="$t('global.importResult.failedDownload')"
              variant="secondary"
            />
          </div>
          <div class="mc-upload-result mc-upload-result--error" style="display: none">
            <figure>
              <img src="@/assets/images/alert-report-danger.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">
              {{ $t('global.importResult.failedUpload') }}
            </h4>
            <ul class="mc-upload-result__detail">
              <li><b>5</b> {{ $t('global.importResult.total') }}</li>
              <li class="text-success"><b>5</b> {{ $t('global.importResult.successData') }}</li>
              <li class="text-danger"><b>5</b> {{ $t('global.importResult.failedData') }}</li>
            </ul>
            <McButton
              icon="icon-outline_download"
              :text="$t('global.importResult.failedDownload')"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
